import { Selector } from '@ngxs/store';
import { AuditState } from '@store/audit/audit.state';
import { AuditStateModel } from '@store/audit/audit-state.model';
import { IAuditLog } from '@interfaces/audit';

export class AuditSelectors {
    @Selector([AuditState])
    static getSections(state: AuditStateModel): { key: string, value: string }[] {
        return state.sections.map((item) => {
            return {key: item, value: item};
        });
    }

    @Selector([AuditState])
    static getActions(state: AuditStateModel): { key: string, value: string }[] {
        const selectedSection = state.selectedSection;
        const actions = state.actions;
        if (selectedSection && actions) {
            return actions[selectedSection].map((item) => {
                return {key: item, value: item};
            });
        }
        return [];
    }

    @Selector([AuditState])
    static isActionDisabled(state: AuditStateModel): boolean {
        return state.selectedSection === null;
    }

    @Selector([AuditState])
    static getUsers(state: AuditStateModel): { key: string, value: number }[] {
        return state.users.map((user) => {
            return {key: user.email, value: user.id};
        });
    }

    @Selector([AuditState])
    static getLogs(state: AuditStateModel): IAuditLog[] {
        return state.logs;
    }

    @Selector([AuditState])
    static isFilterSubmitted(state: AuditStateModel): boolean {
        return state.isFilterSubmitted;
    }

    @Selector([AuditState])
    static searchValue(state: AuditStateModel): string {
        return state.search;
    }

    @Selector([AuditState])
    static isLoading(state: AuditStateModel): boolean {
        return state.loader;
    }

    @Selector([AuditState])
    static itemsPerPage(state: AuditStateModel): number {
        return state.itemsPerPage;
    }

    @Selector([AuditState])
    static currentPage(state: AuditStateModel): number {
        return state.pageNumber;
    }

    @Selector([AuditState])
    static totalLogs(state: AuditStateModel): number {
        return state.totalLogs;
    }

    @Selector([AuditState])
    static getSavedDataForForm(state: AuditStateModel): {
        action: string | null,
        section: string | null, userIds: number[], range: Object | null
    } {
        return {
            action: state.selectedAction,
            section: state.selectedSection,
            userIds: state.selectedUsersIds,
            range: state.range
        };
    }

}
